import * as React from 'react';
import { createPortal } from 'react-dom';

export class Portal extends React.Component<React.PropsWithChildren> {
  private portalTarget: HTMLElement | null = null;

  public componentDidMount() {
    this.portalTarget = document.createElement('div');
    document.body.appendChild(this.portalTarget);
  }

  public componentWillUnmount() {
    if (this.portalTarget) {
      document.body.removeChild(this.portalTarget);
      this.portalTarget = null;
    }
  }

  public render() {
    return this.portalTarget && createPortal(this.props.children, this.portalTarget);
  }
}
